/**
 * The meow pill, bottom-right.  context.js wires the click to meow.js's
 * one-shot; meow.css says why it borrows #open-customizer's accent-pill
 * treatment and dies on touch.
 */
import "./meow.css";
import { mount } from "./dom.js";

export function mountMeowBtn() {
  return mount(`
<!-- The cat's voice on demand; packages/client/src/app/context.js wires it to meow.js.  A
     button as well as a key because it is the one action a mouse-only
     visitor would otherwise never find. -->
<button id="meow-btn" class="panel" type="button" aria-label="Meow">Meow &middot; V</button>`);
}
